// extracted by mini-css-extract-plugin
export default {"PartnersContainer":"Partners_PartnersContainer__cEj6F","Marquee":"Partners_Marquee__URT2k","MarqueeContent":"Partners_MarqueeContent__LXS+3","scroll":"Partners_scroll__0jwen"};